import { render, staticRenderFns } from "./GlobalSingapore.vue?vue&type=template&id=6913613c&"
import script from "./GlobalSingapore.vue?vue&type=script&lang=js&"
export * from "./GlobalSingapore.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSingapore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports